<template>
    <el-main>
        <el-row>
            <el-col :span="3">
                <td-date-time v-model="startTime" :pickerOptions="{ start: '08:30', step: '00:15', end: '18:30', maxTime: endTime }" type="fixedTime"></td-date-time>
            </el-col>
            <el-col :span="3">
                <td-date-time v-model="endTime" :pickerOptions="{ start: '08:30', step: '00:15', end: '18:30', minTime: startTime }" type="fixedTime"></td-date-time>
            </el-col>
        </el-row>
        <el-row>
            <td-date-time v-model="time" :isRange="true" :pickerOptions="{ selectableRange: '18:30:00 - 20:30:00' }" type="time"></td-date-time>
        </el-row>
        <el-row>
            <td-date-time v-model="year" type="year"></td-date-time>
        </el-row>
        <el-row>
            <td-date-time v-model="month" type="month"></td-date-time>
        </el-row>
        <el-row>
            <td-date-time v-model="date" type="date"></td-date-time>
        </el-row>
        <el-row>
            <td-date-time v-model="dates" type="dates"></td-date-time>
        </el-row>
        <el-row>
            <td-date-time v-model="datetime" type="datetime"></td-date-time>
        </el-row>
        <el-row>
            <td-date-time v-model="datetimerange" :pickerOptions="pickerOptions" type="datetimerange"></td-date-time>
        </el-row>
        <el-row>
            <td-date-time v-model="daterange" type="daterange"></td-date-time>
        </el-row>
        <el-row>
            <td-button @click="getTime">获取时间</td-button>
        </el-row>
    </el-main>
</template>
<script>
export default {
    data() {
        return {
            startTime: '',
            endTime: '',
            time: '',
            year: '',
            month: '',
            date: '',
            dates: '',
            week: '',
            datetime: '',
            datetimerange: '',
            daterange: '',
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            }
        };
    },
    methods: {
        getTime() {
            alert(this.startTime);
            alert(this.endTime);
            alert(this.time);
            alert(this.year);
            alert(this.date);
            alert(this.dates);
            alert(this.week);
            alert(this.datetime);
            alert(this.datetimerange);
            alert(this.daterange);
        }
    }
};
</script>
